import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/apiClient";
import { ReportDocument } from "@/components/ReportDocument";
import { ArrowLeft, Download, Loader2 } from "lucide-react";

export default function CombinedReport() {
  const navigate = useNavigate();
  const [reports, setReports] = useState(null);
  useEffect(() => { api.get("/reports/all").then((r) => setReports(r.data)).catch(() => navigate("/dashboard")); }, [navigate]);

  if (!reports) return <div className="flex min-h-screen items-center justify-center bg-neutral-900"><Loader2 className="h-6 w-6 animate-spin text-[#c5a24a]" /></div>;

  return (
    <div className="min-h-screen bg-neutral-900 py-8">
      <div className="no-print mx-auto mb-6 flex max-w-[8.5in] items-center justify-between px-2">
        <button onClick={() => navigate("/reports")} className="flex items-center gap-1.5 text-sm font-semibold text-neutral-400 hover:text-[#c5a24a]"><ArrowLeft className="h-4 w-4" /> Back</button>
        <div className="text-sm font-semibold text-neutral-300">Combined Report — {reports.length} projects</div>
        <button onClick={() => window.print()} data-testid="download-pdf-btn" className="gold-gradient flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-[#121212] hover:opacity-90"><Download className="h-4 w-4" /> Download PDF</button>
      </div>
      <div className="space-y-8">
        {reports.map((r, i) => (
          <div key={i} style={{ breakAfter: "page", pageBreakAfter: "always" }}>
            <ReportDocument report={r} />
          </div>
        ))}
      </div>
    </div>
  );
}
